import conf from '../config/api.js';
import Vue from 'vue';
import script from './script.js'
import vuexStorage from '../store/index.js'
var moment = require('moment');
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction pour récupérer les notes de frais
async function getNotesDeFrais () {
  try {
    let notesDeFrais = await requestApi({method: 'GET', url: '/api/notesDeFrais', params: {}, headers: {'Content-Type': 'application/json'}})
    this.notesDeFraisList = notesDeFrais
  } catch (error) {
    if(error.response != undefined){
      script.toasterError(`Impossible de récupérer les notes de frais`,'Récupération notes de frais')
    }else{
      script.toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction pour créer une note de frais
async function createNoteDeFrais (noteDeFrais) {
  try {
    await requestApi({method: 'POST', url: '/api/createNoteDeFrais', params: {}, form: {noteDeFrais : noteDeFrais}, headers: {'Content-Type': 'application/json'}})
    script.toasterSuccess(`La note de frais a été créée`,'Création note de frais')
  } catch (error) {
    if(error.response != undefined){
      script.toasterError(`Impossible de créer la note de frais`,'Création note de frais')
    }else{
      script.toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction pour supprimer une note de frais
async function deleteNoteDeFrais (idNoteDeFrais) {
  try {
    await requestApi({method: 'DELETE', url: '/api/deleteNoteDeFrais', params: {idNoteDeFrais : idNoteDeFrais}, headers: {'Content-Type': 'application/json'}})
    script.toasterSuccess(`La note de frais a été supprimée`,'Suppression note de frais')
  } catch (error) {
    if(error.response != undefined){
      script.toasterError(`Impossible de supprimer la note de frais`,'Suppression note de frais')
    }else{
      script.toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction qui envoie le fichier d'une note de frais
async function uploadFileNoteDeFrais (idNoteDeFrais, file) {
  try {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('idNoteDeFrais', idNoteDeFrais);
    await requestApi({method: 'POST', url: '/api/uploadFileNoteDeFrais', params: {}, form: formData, headers: {'Content-Type': 'multipart/form-data'}})
    script.toasterSuccess(`Le fichier a été uploadé`,'Upload fichier note de frais')
  } catch (error) {
    if(error.response != undefined){
      script.toasterError(`Impossible d'uploader le fichier`,'Upload fichier note de frais')
    }else{
      script.toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}


// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
    return new Promise((resolve, reject) => {
        new Vue().axios({
            method: options.method,
            url: conf.server + options.url,
            params: options.params,
            data: options.form,
            headers: options.headers,
            withCredentials: true
        }).then((response) => {
            resolve(response.data)
        }).catch((error) => {
            reject(error)
        })
    })
}

export default {
    getNotesDeFrais,
    createNoteDeFrais,
    deleteNoteDeFrais,
    uploadFileNoteDeFrais
}
